<template>
  <v-container fluid class="ma-0 pa-0">
      <PrivacyPolicyHk v-if="getLang==='hk'"/>
      <PrivacyPolicySg v-if="getLang==='sg'"/>
      <PrivacyPolicyTh v-if="getLang==='th'"/>
  </v-container>
</template>

<script>
import PremiumApi from "@/plugins/axios";
import PrivacyPolicyHk from "@/components/FormComponents/hk/PrivacyPolicy-hk";
import PrivacyPolicySg from "@/components/FormComponents/sg/PrivacyPolicy-sg";
import PrivacyPolicyTh from "@/components/FormComponents/th/PrivacyPolicy-th";


export default {
  components: {
    PrivacyPolicyHk,
    PrivacyPolicySg,
    PrivacyPolicyTh
  },
  data() {
    return {
      valid: false
    };
  },
  methods: {
    trackPage: function() {
      const postData = this.$store.state.accessData;
      postData.url = window.location.href + "/PersonalInfoCollection";
      PremiumApi.logAccess(postData, function(data) {
        console.log("Data sent with : " + JSON.stringify(postData));
      });
    },
  },
  mounted: function() {
    window.scrollTo(0, 0);
    const hasIpAddress = !this.$store.state.accessData.ipAddress ? false : true;
    if (hasIpAddress) {
      this.trackPage();
    } else {
      const _this = this;
      PremiumApi.getIpAddress(function(data) {
        _this.$store.dispatch("saveIpAddress", data);
        _this.trackPage();
      });
    }
  },
  computed: {
    getLang() {
      //return this.$store.state.country === "hk" ? "hk" : "sg";
      if(this.$store.state.country === "hk"){
        return "hk";
      }else if(this.$store.state.country === "th"){
        return "th";
      }else {
        return "sg";
      }
    },
  },
};
</script>
